import Progbar from '@pages/GoalsPage/components/Progbar';

import { Title, Text, ProgbarContainer } from '../OnboardingStyles';

const ProfessionalGoals = () => (
  <>
    <ProgbarContainer>
      <Progbar currentStep={3} totalSteps={5} />
    </ProgbarContainer>
    <Title>🎯 Tell us your top 3 professional goals</Title>
    <br />
    <Text>
      These are the outcomes you want to achieve in your current role - whether they’re about
      growth, efficiency, team impact, or strategic influence.
    </Text>
    <br />
    <Text>
      Once you set your goals, Jamie will create a personalized strategic plan to help you get
      there.
    </Text>
    <br />
    <Text>
      She’ll support you along the way with tailored suggestions, analysis, and prioritization.
    </Text>
  </>
);

export default ProfessionalGoals;
